// extracted by mini-css-extract-plugin
export default {"container":"OY-z","list":"PY-z"};